// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".address-content[data-v-454a7db5]{padding-bottom:32px}", ""]);
// Exports
module.exports = exports;
